"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledIs = _interopRequireDefault(require("styled-is"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _fonts = require("../../styles/fonts");
var _templateObject, _templateObject2;
var Text = _styledComponents["default"].span.withConfig({
  displayName: "HBCustomText__Text",
  componentId: "sc-h5pnj7-0"
})(["", " ", " color:", ";font-family:", ";font-size:", ";line-height:", ";"], (0, _styledIs["default"])('$align')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n\t\ttext-align: ", ";\n\t"])), function (props) {
  return props.$align;
}), (0, _styledIs["default"])('$weight')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n\t\tfont-weight: ", ";\n\t"])), function (props) {
  return props.$weight;
}), function (props) {
  return props.$color;
}, function (props) {
  var _customFont$props$$fo;
  return ((_customFont$props$$fo = _fonts.customFont[props.$fontFamily]) === null || _customFont$props$$fo === void 0 ? void 0 : _customFont$props$$fo.font_family) || "".concat(props.$fontFamily, ", 'ProximaNova'");
}, function (props) {
  return props.$fontSize;
}, function (props) {
  return props.$lineHeight;
});
var HBCustomText = function HBCustomText(_ref) {
  var _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? 'span' : _ref$tag,
    children = _ref.children,
    className = _ref.className,
    align = _ref.align,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? '400' : _ref$weight,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _colors["default"].black : _ref$color,
    _ref$fontFamily = _ref.fontFamily,
    fontFamily = _ref$fontFamily === void 0 ? 'ProximaNova' : _ref$fontFamily,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? '16px' : _ref$fontSize,
    _ref$lineHeight = _ref.lineHeight,
    lineHeight = _ref$lineHeight === void 0 ? '1.3' : _ref$lineHeight;
  return /*#__PURE__*/_react["default"].createElement(Text, {
    as: tag,
    className: className,
    $align: align,
    $weight: weight,
    $color: color,
    $fontFamily: fontFamily,
    $fontSize: fontSize,
    $lineHeight: lineHeight
  }, children);
};
var _default = exports["default"] = HBCustomText;
//# sourceMappingURL=HBCustomText.js.map